import React from 'react';
import { IProps as IBlockProps } from './HeroDonationBlock.interface';
import { HeroDonationBlock } from './HeroDonationBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IBlockInputProps {
    heading?: string;
    content?: string;
    image?: any;
    donation?: any;
    [key: string]: any; // Allow passthrough of other props
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const { image, heading, content, buttons, donation, ...rest } = input;

    return {
        title: heading,
        description: content,
        donateform: donation,
        backgroundGradient: 'gradient-1',
        backgroundImage: image ? translation.mapImageProps(image) : undefined,
        paddingBottom: 'small',
        paddingTop: 'small',
        ...rest,
    } as IBlockProps;
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={HeroDonationBlock}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;